import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthenticatedFetch } from "@/hooks/use-authenticated-fetch";
import { projectKeys } from "@/lib/query-keys";
import type { ProjectTag } from "@/types/api";

export function useCreateTag(projectId: string) {
  const fetchWithAuth = useAuthenticatedFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (name: string) => {
      return fetchWithAuth<ProjectTag>(
        `/projects/1.0/projects/${projectId}/tags/`,
        {
          method: "POST",
          body: JSON.stringify({ name }),
        },
      );
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.detail(projectId),
      });
    },
  });
}

export function useUpdateTag(projectId: string) {
  const fetchWithAuth = useAuthenticatedFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ tagId, name }: { tagId: string; name: string }) => {
      return fetchWithAuth<ProjectTag>(
        `/projects/1.0/projects/${projectId}/tags/${tagId}/`,
        {
          method: "PATCH",
          body: JSON.stringify({ name }),
        },
      );
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.detail(projectId),
      });
    },
  });
}

export function useDeleteTag(projectId: string) {
  const fetchWithAuth = useAuthenticatedFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tagId: string) => {
      return fetchWithAuth<void>(
        `/projects/1.0/projects/${projectId}/tags/${tagId}/`,
        { method: "DELETE" },
      );
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.detail(projectId),
      });
    },
  });
}
